import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { InputText } from 'primereact/inputtext'
import { t } from 'i18next'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { supabase } from 'Services/supabaseClient'
import { TABLE_CONST } from 'Utils/Constants'
import { DialogModal } from 'Components/UIComponents'
import Loader from 'Components/Loader'
import LayoutContainer from 'Components/LayoutComponent'

const CommunityUsers = ({ setLoading }) => {
  const history = useHistory()
  const communityId = history?.location?.state
  const categories = [
    { name: 'Regular', key: 'R' },
    { name: 'Gold', key: 'G' },
    { name: 'Platinum', key: 'P' }
  ]

  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const [usersData, setUsersData] = useState([])
  const [allUsersData, setAllUsersData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [dialogState, setDialogState] = useState({
    showModal: false,
    modalType: '',
    message: '',
    onSuccess: () => {},
    onHide: () => {},
    onRetry: () => handleDismiss(),
    onDismiss: () => handleDismiss()
  })

  const rowCount = windowSize < TABLE_CONST.maxWidthTab ? TABLE_CONST.mobileRowCount : 5
  const paginationButtons = windowSize < TABLE_CONST.maxWidthTab ? TABLE_CONST.mobilePaginationButtonCount : TABLE_CONST.paginationButtonCount

  useEffect(() => {
    fetchCommunityUsers()

    const handleWindowResize = () => {
      setWindowSize(window.innerWidth)
    }

    window.addEventListener('resize', handleWindowResize)

    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  const fetchCommunityUsers = async () => {
    try {
      setLoading(true)

      const { data: membersData, error: membersError } = await supabase.from('community_members').select('userid').eq('community_id', communityId?.id)

      if (membersError) {
        setDialogState({
          showModal: true,
          modalType: 'error',
          message: t('FAILED_TO_PROCESS_REQUEST'),
          onHide: handleDismiss,
          onRetry: () => fetchCommunityUsers()
        })

        return
      }

      if (!membersData || membersData.length === 0) {
        setLoading(false)

        return
      }

      const userIds = membersData.map((member) => member.userid)

      const { data: usersData, error: usersError } = await supabase.from('users').select('userid, first_name, last_name, email, phone, subscription_type').in('userid', userIds)

      if (usersError) {
        setDialogState({
          showModal: true,
          modalType: 'error',
          message: t('FAILED_TO_PROCESS_REQUEST'),
          onHide: handleDismiss,
          onRetry: () => fetchCommunityUsers()
        })

        return
      }

      const users = usersData.map((user) => ({
        userId: user.userid,
        firstName: user.first_name + ' ' + user.last_name, //eslint-disable-line
        email: user.email,
        phone: user.phone,
        subscription: categories.find((u) => u.key === user.subscription_type)?.name
      }))

      console.log(usersData)

      setUsersData(users)
      setAllUsersData(users)
    } catch (error) {
      setDialogState({
        showModal: true,
        modalType: 'info',
        message: t('SORRY_COULD_NOT_FETCH_THE_DATA_PLEASE_TRY_AGAIN_LATER'),
        onConfirmation: () => fetchCommunityUsers(),
        onHide: handleDismiss
      })
    } finally {
      setLoading(false)
    }
  }

  const handleSearchChange = (e) => {
    const searchValue = e.target?.value?.toLowerCase()

    setSearchTerm(searchValue)

    if (!searchValue) {
      setUsersData(allUsersData)
    } else {
      const filteredUsers = allUsersData?.filter((user) => user?.firstName?.toLowerCase()?.includes(searchValue) || user?.email?.toLowerCase()?.includes(searchValue) || user?.userId?.toString()?.includes(searchValue))

      setUsersData(filteredUsers)
    }
  }

  const handleDismiss = () => {
    setDialogState((prevState) => ({ ...prevState, showModal: false }))
  }

  const actionTemplate = () => (
    <div className="action-container">
      <Button type="button" icon="pi pi-trash" className="community-users-delete-icon" tooltip={t('DELETE')} tooltipOptions={{ position: 'top' }} />
    </div>
  )

  const columns = [
    { dataField: 'userId', text: t('Id'), className: 'id-column', isSortable: true },
    { dataField: 'firstName', text: t('NAME'), className: 'name-column', isSortable: true },
    { dataField: 'email', text: t('EMAIL'), className: 'email-column', isSortable: true },
    { dataField: 'phone', text: t('PHONE'), className: 'phone-column', isSortable: true },
    { dataField: 'subscription', text: t('SUBSCRIPTION'), className: 'subscription-column', isSortable: true },
    { body: actionTemplate, text: t('ACTIONS'), className: 'edit-column' }
  ]

  return (
    <LayoutContainer title={t('COMMUNITY_USERS')} breadCrumbsTitle={'communityUsers'}>
      <div className="community-management-div">
        <div className="search-div p-input-icon-left">
          <i className="pi pi-search" data-testid="search-icon" />
          <InputText value={searchTerm} placeholder={t('SEARCH')} onChange={handleSearchChange} />
        </div>
        <div className="table-div">
          <DataTable value={usersData} removableSort paginator rows={rowCount} pageLinkSize={paginationButtons} scrollHeight="550px" scrollable>
            {columns.map((col, i) => (
              <Column key={i} field={col.dataField} sortable={col.isSortable} header={col.text} body={col.body} className={col.className} />
            ))}
          </DataTable>
        </div>
      </div>
      <DialogModal {...dialogState} />
    </LayoutContainer>
  )
}

export default Loader(CommunityUsers)
